<template>
  <div>
    <div class="d-flex justify-end mb-4">
      <v-tooltip bottom v-if="selected && selected.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            depressed
            class="mb-2 mr-2 primary-button"
            dark
            @click="getZip"
          >
            {{ $t('Baixar certificados') }}
          </v-btn>
        </template>
        <span>{{ $t('Máximo de 25 arquivos por vez') }}</span>
      </v-tooltip>

      <v-btn color="primary-button" depressed @click="filters = !filters">
        {{ filters ? $t('Fechar filtros') : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div class="d-flex" v-if="filters">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.osNumber"
              :label="$t('Nº O.S.')"
              class="primary-input"
              outlined
              dense
              hide-details
              style="max-width: 400px"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              class="primary-input"
              single-line
              :items="[
                { text: $t('Sim'), value: true },
                { text: $t('Não'), value: false },
              ]"
              item-text="text"
              item-value="value"
              clearable
              style="max-width: 400px"
              hide-details="auto"
              v-model="filter.isValidated"
              outlined
              :placeholder="$t('Checklist validado')"
              append-icon="mdi-chevron-down"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="3">
            <v-autocomplete
              dense
              hide-details
              single-line
              :items="[
                { text: $t('Sim'), value: true },
                { text: $t('Não'), value: false },
              ]"
              item-text="text"
              item-value="value"
              clearable
              v-model="filter.approved"
              outlined
              class="primary-input"
              append-icon="mdi-chevron-down"
              :placeholder="$t('Aprovação')"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-end">
            <v-btn class="primary-button ml-2 mt-1" depressed @click="list">
              {{ $t('Filtrar') }}
            </v-btn>

            <v-btn
              depressed
              color="#20202066"
              class="clear-button ml-2"
              @click="reset"
            >
              {{ $t('Limpar') }}
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-expand-transition>

    <v-data-table
      :no-data-text="$t('Nenhum item encontrado')"
      class="main-table"
      :headers="headers"
      :items="checklists"
      show-select
      v-model="selected"
      :items-per-page="20"
      hide-default-footer
      hide-default-header
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.executionDate`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template #[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template #[`item.answerTemplate.type`]="{ item }">
        {{ $t(types[item.answerTemplate.type]) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :to="`/editServiceOrder/${item.serviceOrderId}`"
              :color="
                item.serviceOrder.closeServiceOrderDateTime
                  ? '#B9CE1E'
                  : '#F5F5F5'
              "
              dark
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon color="#2A8EA4" small> mdi-view-module </v-icon>
            </v-btn>
          </template>
          <span>Ordem de Serviço</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              :to="`/inspectionRoutineChecklist/manage?id=${item.id}`"
              target="_blank"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              dark
              :to="`/inspectionRoutineChecklist/print?id=${item.id}`"
              target="_blank"
              :color="item.approved ? `#BBCF20` : `error`"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small color="#F5F5F5"> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <div class="registros" v-if="checklists.length">
          <span> 1 - {{ checklists.length }} de {{ filter.totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'

export default {
  name: 'InspectionRoutineChecklistPage',

  created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id

    this.filter.institutionId = this.institutionId

    this.list()
  },

  data() {
    return {
      loading: false,
      filters: false,
      filter: {
        page: 1,
      },
      page: 1,
      checklists: [],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
          sortable: false,
        },
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrder.number',
          sortable: false,
        },
        {
          text: 'Tipo',
          align: 'center',
          value: 'answerTemplate.type',
          sortable: false,
        },
        {
          text: 'Executado em',
          align: 'center',
          value: 'executionDate',
          sortable: false,
        },
        {
          text: 'Criado em',
          align: 'center',
          value: 'createdAt',
          sortable: false,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      types: ['Equipamento', 'Setor'],
      apiService: new ApiService(),
      selected: [],
    }
  },

  methods: {
    async getZip() {
      this.$toast(
        `${this.$t('Imprimindo registros')}: ${this.selected.length} ${this.$t(
          'selecionados'
        )}`
      )
      const ids = this.selected.map((x) => x.id)
      await this.apiService
        .post(`inspectionRoutineChecklist/getZipChecklist`, { ids })
        .then((response) => {
          var pedfResult = 'data:application/zip;base64,' + response.content
          const link = document.createElement('a')
          link.href = pedfResult
          link.setAttribute('download', `Checklists`)
          document.body.appendChild(link)
          link.click()
          this.selected = []
        })
    },

    reset() {
      this.filter = {
        page: 1,
        institutionId: this.institutionId,
      }
      this.list()
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    list() {
      this.apiService
        .post('inspectionRoutineChecklist/list/paginate', this.filter)
        .then((response) => {
          this.checklists = response.content.checklists
          this.filter.totalItems = response.content.pager.totalItems
          this.filter.totalPages = response.content.pager.totalPages
        })
    },
  },

  watch: {
    selected(val) {
      if (val.length > 25) {
        this.$nextTick(() => {
          this.selected = val.slice(0, 25)
        })
      }
    },
    page() {
      this.filter.page = this.page
      this.list()
    },
  },
}
</script>

<style></style>
